import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { Host } from '../../../Host';
import { EditorSession } from '../../canvas/EditorSession';
import { Physicals } from '../../canvas/entities/Physicals';
import { Selection } from '../../canvas/Selection';
import { PopupManager } from '../../popups/PopupManager';
import { alert } from '../alerts/AlertCommands';
import { Sticky } from '../paper/Sticky';
import { exportPdfPopup } from './ExportPdfPopup';
import { exportPopup } from './ExportPopup';

export const exportData = defineCommand(
    'exportData',
    'Export: Data...',
    async r => {
        const popups = r.call(PopupManager);
        await popups.invoke(exportPopup());
    }
);

export const exportPdf = defineCommand(
    'exportPdf',
    'Export: PDF...',
    async r => {

        const popups = r.call(PopupManager);
        await popups.invoke(exportPdfPopup());
    }
);

export const exportTrello = defineCommand(
    'exportTrello',
    null,
    async (r, [name]: [string]) => {
        if (!name) return;

        const api = r.call(ApiClient);
        const dispatch = r.call(CommandDispatcher);

        const selection = r.call(EditorSession).get(Selection);
        const stickies = Physicals.polarize(selection, Sticky);
        if (stickies.length === 0) {
            dispatch(alert, ['No stickies selected!']);
        }
        else {
            try {
                const items = stickies.map(x => x.content);
                await api.exec(v2.export.trello(name, items));
            }
            catch (e) {
                dispatch(alert, [
                    `Export failed!  Have you connected your Trello account at: 
                    ${Host.baseUrl}/connect/trello`
                ]);
            }
        }


    },
    [
        stringStep('boardName', 'Enter Trello board name:')
    ]
);
